"use strict";

var timeZone = "America/Denver";
var moment = require('moment-timezone');

module.exports = function coerceDatetime(x) {
	if (!x) return null;
	var d;
	var y = x.toString().replace(/\//g, '-');

	// Accepts ISO or local datetime strings
	if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(y)) {
		d = moment.tz(y, moment.ISO_8601, timeZone);
	} else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(y)) {
		d = moment.tz(y, "YYYY-MM-DD HH:mm", timeZone);
	} else {
		// fallback: try parsing as date
		d = moment.tz(y, timeZone);
	}

	if (!d || !d.isValid()) return null;
	return d.toDate();
}; 